export default __webpack_public_path__ + "img/9f81c12106c3d410310641f28c475fcd.png";